/// <reference path="../../app.ts" />
namespace Cfnc {
    "use strict";

    interface IStartNewAppScope extends ng.IScope {
        organizations: Array<any>;
        limitSchools: number;
        close: () => void;
        schoolid: number;
        crossroadsUrl: string;
        selectedApp: string;
        openApp: (selectedApp) => void;
        hasApplications: (organization: any) => boolean;
    }

    interface IStartNewApp {
    }

    class StartNewApp implements IStartNewApp {
        static controllerId: string = "startNewAppModal";
        private log;

        constructor(
            private $window: ng.IWindowService,
            private organizationDataService: IOrganizationDataService,
            private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            private $scope: IStartNewAppScope,
            private common: ICommonFactory,
            private config: IConfig,
            schoolid: string,
            private Restanuglar: Restangular.IService) {

            $scope.organizations = [];
            $scope.crossroadsUrl = config.crossroadsUrl;
            this.log = common.logger.getLogFn(StartNewApp.controllerId);
            if (schoolid) {
                organizationDataService.getOrganizationById(schoolid).then((data) => {
                    if (data) {
                        $scope.organizations.push(data);
                    }
                });
            }
            else {
                organizationDataService.getOrganizations().then((data) => {

                    $scope.organizations = data;
                });
            }

            $scope.limitSchools = 10;
            $scope.close = this.close;
            $scope.hasApplications = this.hasApplications;
            
            this.$scope.$root.$on(config.events.logout, (data: any): void => {
                this.$uibModalInstance.close();
                
            });

            $scope.openApp = (selectedApp) => {
                var url = selectedApp.split(",")[0];
                var appId = selectedApp.split(",")[1];

                
                    var appWindow = $window.open(config.crossroadsUrl + "/application/" + url, "_blank");
                    this.$uibModalInstance.close({ window: appWindow });
                }, () => {
                    this.$uibModalInstance.close();
            };
        }

        hasApplications = (organization: any) => {
            var hasApps = false;
            if (organization.programs.length > 0) {
                organization.programs.forEach((program) => {
                    if (program.applications.length > 0) {
                        hasApps = true;
                    }
                })

            }

            return hasApps;
        }

        close = () => {
            this.$uibModalInstance.close();
        }
    }


    angular.module("app").controller(StartNewApp.controllerId, ["$window", "organizationDataService", "$uibModalInstance", "$scope", "common", "config", "schoolid", "Restangular", (
        $window: ng.IWindowService,
        organizationDataService: IOrganizationDataService,
        $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
        $scope: IStartNewAppScope,
        common: ICommonFactory,
        config: IConfig,
        schoolid: string,
        Restangular: Restangular.IService) =>
        new StartNewApp($window, organizationDataService, $uibModalInstance, $scope, common, config, schoolid, Restangular)
    ]);
}